module.exports = "/images/et.svg?214f121578db00223a847c4611c98f69";